var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"seg-type-desc box"},[_c('div',{staticClass:"seg-type-list"},_vm._l((_vm.descList),function(td,index){return _c('p',{key:index},[_c('span',{staticClass:"td-title"},[_vm._v(_vm._s(td.title)+"：")]),_c('span',{staticClass:"td-value"},[_vm._v(_vm._s(td.value))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }